import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { DownloadActivationCodesForm } from '~/features/DownloadActivationCodesForm';
import styles from './index.module.scss';

export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[
          { label: '利用者一覧', href: '/users' },
          { label: 'アクティベーションコードをダウンロード' },
        ]}
      />
      <div className={styles.content}>
        <span className={styles.content__title}>アクティベーションコードのダウンロード</span>
        <Suspense fallback={<Loader />}>
          <DownloadActivationCodesForm />
        </Suspense>
      </div>
    </>
  );
};
